export default __webpack_public_path__ + "static/fv-black-text-pattern-pc-cc24cb7463b8f08545db4fd745b3c47c.png";